/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';
import { Layout } from 'antd';
import css from './css.less';
import Sider from 'src/layout/Components/SiderVertical/VerticalSider';
import HorizontalSider from 'src/layout/Components/SiderHorizental/HorizentalSider';
import TopHeader from 'src/layout/TopHeader/TopHeader';
import { useSelector } from 'react-redux';
import {
  headerHeight,
  horizentalMenuHeight,
} from 'src/layout/Components/config';
import { getUserName } from 'src/tools/getUserInfo';
//import { useI18n } from 'src/hooks/useRouterChange';
//import { i18nGet } from 'src/tools/tools';

//import routes from '@/src/config/routerConfig/mainPages/SettingPage';

const { Header, Content } = Layout;
const PageStructure = (props) => {
  //const i18n = useI18n();
  //const getI18n = (str) => i18nGet(i18n, str);
  const {
    menuArray,
    children,
    extraHeader = {},
    trigger,
    siderClassName,
    onContentClick,
  } = props;
  //const name = getUserName() || 'Portal';
  const { extraHeaderHeight = 0 } = extraHeader;
  const position = useSelector((state: any) => state.mainLayout.position);

  const isHorizental = React.useMemo(() => {
    return position === 'Horizental';
  }, [position]);
  const topPadding = React.useMemo(() => {
    if (isHorizental) {
      return headerHeight + horizentalMenuHeight + extraHeaderHeight;
    } else {
      return headerHeight + extraHeaderHeight;
    }
  }, [isHorizental, extraHeader]);
  const siderBar = React.useMemo(() => {
    if (menuArray) {
      if (isHorizental) {
        return (
          <div className={css.siderBarHorizental} style={{ top: headerHeight }}>
            <HorizontalSider height={horizentalMenuHeight} />
          </div>
        );
      } else {
        return (
          <div className={css.siderBarVertical}>
            <Sider
              topPadding={topPadding}
              siderClassName={siderClassName}
              menuArray={menuArray}
              trigger={trigger}
            />
          </div>
        );
      }
    }
    return null;
  }, [isHorizental, trigger, menuArray]);

  // const plusSquare = [
  //   {
  //     name: getI18n('general.storeCommunicationSetting.product'),
  //     list: [
  //       {
  //         link: '/product/simpleProduct/new',
  //         text: getI18n('general.simpleProduct.simpleProduct'),
  //       },
  //       {
  //         link: '/product/productSet/new',
  //         text: getI18n('general.productSet.productSet'),
  //       },
  //       // {
  //       //   link: '/product/variantProduct/new',
  //       //   text: 'Variant Product',
  //       // },
  //     ],
  //   },
  //   // {
  //   //   name: 'Order',
  //   //   list: [
  //   //     {
  //   //       link: 'www.baidu.com',
  //   //       text: 'Item1',
  //   //     },
  //   //     {
  //   //       link: 'www.baidu.com',
  //   //       text: 'Item2',
  //   //     },
  //   //   ],
  //   // },
  // ];

  return (
    <section
      className={css.contentContainer}
      style={{
        paddingTop: topPadding,
        flexDirection: isHorizental ? 'column' : 'row',
      }}>
      {siderBar}
      <Content className={css.content} onClick={onContentClick}>
        <div id='tcContentTop' />

        {/* //scrollTo Bug TODO */}
        {children}
      </Content>
    </section>
    // <Layout className={css.wrapper}>
    //   <Header className={css.header}>
    //     <TopHeader userName={name} />
    //     {extraHeaderComponent}
    //   </Header>
    //   <section
    //     className={css.contentContainer}
    //     style={{
    //       paddingTop: topPadding,
    //       flexDirection: isHorizental ? 'column' : 'row',
    //     }}>
    //     {siderBar}
    //     <Content className={css.content} onClick={onContentClick}>
    //       <div id='tcContentTop' />

    //       {/* //scrollTo Bug TODO */}
    //       {children}
    //     </Content>
    //   </section>
    // </Layout>
  );
};
export default PageStructure;
const Container = (props) => {
  const name = getUserName() || 'Portal';
  return (
    <Layout className={css.wrapper}>
      <Header className={css.header}>
        <TopHeader userName={name} />
      </Header>
      {props.children}
    </Layout>
  );
};
export { Container };
